import {
  Box,
  Button,
  Chip,
  Grid,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { CheckCircle } from "@material-ui/icons";
import * as format from "date-fns/format";
import { isEqual, uniq } from "lodash";
import React from "react";
import Component from "src/components/Component";
import Modal from "src/components/Modal";
import { searchFilter } from "src/components/SearchBar";
import withAxios from "src/components/withAxios";
import { IUser } from "src/services";
import {
  ICoach,
  IDirectorParams,
  IEvaluationRequest,
  ISurvey,
  ISurveyCountResponse,
  ISurveyResponse,
  TemplateType,
} from "src/services";
import CoachRow from "./components/coach-row/CoachRow";
import { SurveyLink } from "./components/survey-link/SurveyLink";
import { EVALUATION_CATEGORIES } from "./components/survey-link/constants";
import { styles } from "./styles";
import { IProps, ISportTableState } from "./types";
import { Alert } from "@material-ui/lab";
import { EVALUATIONS_COMPLETED } from "./constants";

export default withStyles(styles, { withTheme: true })(
  withAxios(
    class SportTable extends Component<IProps, ISportTableState> {
      public static readonly EVALUATION_TIMEOUT = 10000000;
      public readonly state = this.buildState({
        cancelEvaluationModalVisible: false,
        cancelEvaluationSubmitting: false,
        continueEvaluationModalVisible: false,
        continueEvaluationSubmitting: false,
        counts: [],
        endEvaluationSubmitting: false,
        loadingResponseCount: false,
        startEvaluationModalVisible: false,
        startEvaluationSubmitting: false,
        addonIDs: [],
        coachiD: -1,
        eachcoachiD: -1
      });

      public componentDidMount() {
        // const addonIDs=this.props?.userSubscription?.addon?.length>0
        let addonIDs: any = []
        if (Object.keys(this.props?.userSubscription).length > 0) {
          if (this.props?.userSubscription?.addon?.length > 0) {
            addonIDs = this.props?.userSubscription?.addon.map((item: any) => Number(item?.addon?.id))
          }
        }
        this.setState({ addonIDs })
        this.loadResponseCount();
      }

      public componentDidUpdate(prevProps: IProps) {
        if (!isEqual(prevProps.surveys[0], this.props.surveys[0])) {
          this.loadResponseCount();
        }
      }

      public render() {
        const {
          search,
          sport,
          coaches,
          surveys,
          showInactive,
          onlyShowInactive,
          midSeasonCheckin
        } = this.props;
        // TODO make this filter faster
        const sportTableCoaches = searchFilter(
          coaches.filter((coach) => {
            return (
              !!coach.sports.find((coachSport) => sport.id === coachSport.id) &&
              (coach.active || showInactive) &&
              !(coach.active && onlyShowInactive)
            );
          }),
          search,
          ["name"]
        );

        const sportTableCoachesOldSport = ((): ICoach[] => {
          if (coaches !== undefined) {
            const uniqueCoachIds = uniq(
              [].concat.apply(
                [],
                surveys.map((s) => s.coachIds)
              )
            ).filter((coachId) => {
              const findCoach = coaches.find((coach) => coach.id === coachId);
              // happens if a coach is deleted
              if (findCoach === undefined) {
                return false;
              }
              const sportTableCoach = findCoach.sports.find(
                (coachSport) => sport.id === coachSport.id
              );
              // filter out coaches that are still in the sport
              return sportTableCoach === undefined;
            });
            return searchFilter(
              coaches.filter((coach) => {
                return (
                  uniqueCoachIds.find((uCI) => uCI === coach.id) &&
                  (coach.active || showInactive) &&
                  !(coach.active && onlyShowInactive)
                );
              }),
              search,
              ["name"]
            );
          }
          return [];
        })();

        if (
          sportTableCoaches.length === 0 &&
          sportTableCoachesOldSport.length === 0
        ) {
          return null;
        }

        const survey = surveys[0];
        
        const activeCoachesOfCurrentSport = coaches.filter((coach) => {
          const isCoachOfCurrentSport = !!coach.sports.find(
            (coachSport) => sport.id === coachSport.id
          );
          const isCoachActive = coach.active;
          return isCoachOfCurrentSport && isCoachActive;
        });
        const areAllCoachesCompleted = activeCoachesOfCurrentSport.every(
          (coach) => survey?.completedSurveyCoachIds.includes(coach.id)
        );

        return (
          <div className="sport-table" key={sport.id}>
            {this.renderCancelEvaluationModal()}
            {this.renderStartEvaluationModal()}
            {this.renderContinueEvaluationModal()}        
            <Box
              alignItems="center"
              display="flex"
              flexWrap="nowrap"
              justifyContent="space-between"
              gridGap="1.5rem"
            >
              <Box display="flex" alignItems="center" gridGap="1.5rem">
                <Typography variant="h5">{sport.name}</Typography>
                {areAllCoachesCompleted && (
                  <Chip
                    color="secondary"
                    size="small"
                    icon={<CheckCircle />}
                    label={EVALUATIONS_COMPLETED}
                  />
                )}
              </Box>
              {midSeasonCheckin === false &&
              <>
              {this.renderSportHeaderButtons(areAllCoachesCompleted)}
              </>
            } 
            </Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{width:"5%"}}>Options</TableCell>
                  <TableCell style={{width:"10%"}}>{this.props?.schoolData?.isAdSurvey === true ? "AD":
                  "Teacher"} Name</TableCell>
                  {midSeasonCheckin === true &&
                  <TableCell style={{width:"8%"}}>Survey Link</TableCell> }
                  <TableCell style={{width:"7%"}}>Surveys</TableCell>
                  <TableCell style={{width:"10%"}}>Response Count</TableCell>
                  <TableCell style={{width:"8%" }}>
                    <span style={{ paddingRight: "50px" }}>
                      {(() => {
                        if (this.showEvaluations(survey)) {
                          if (survey.responseCollectionEndDate !== null) {
                            return format(
                              survey.responseCollectionEndDate,
                              "MMM/DD/YYYY"
                            );
                          }
                        }
                        if (survey !== undefined) {
                          return format(survey.startDate, "MMM/DD/YYYY");
                        }
                        return null;
                      })()}
                    </span>
                  </TableCell>
                  {midSeasonCheckin === true &&
                  <TableCell style={{width:"10%"}}>Action</TableCell>
      }
                </TableRow>
              </TableHead>
              <TableBody>
                {/* {console.log("sportTableCoaches", sportTableCoaches)} */}
                {sportTableCoaches.map((coach) =>
                  this.renderCoachRow(coach, survey)
                )}
              </TableBody>
            </Table>
          </div>
        );
      }

      private renderCoachRow = (
        coach: ICoach,
        survey: ISurvey,
        oldSport?: boolean
      ) => {
        this.setState({eachcoachiD: coach?.id})
        const { sport, surveys, school,coaches, menuAnchor,midSeasonCheckin, loadSurveys, handleSendEvalModalVisible } = this.props;
        const isCoachEvaluationCompleted =
          !!survey?.completedSurveyCoachIds.includes(coach.id);

        return (
          <CoachRow
            key={coach.id}
            oldSport={oldSport}
            sport={sport}
            surveys={surveys}
            school={school}
            coach={coach}
            schoolData={this.props.schoolData}
            submittedSurvey={isCoachEvaluationCompleted}
            loadingResponseCount={this.state.loadingResponseCount}
            cancelEvaluationSubmitting={this.state.cancelEvaluationSubmitting}
        continueEvaluationSubmitting={this.state.continueEvaluationSubmitting}
        startNewEvaluationSubmitting={this.state.startEvaluationSubmitting}
            // count={midSeasonCheckin ?(this.state.counts as any) : this.state.counts.find(
            //   (count) => count.coachId === coach.id
            // )}
            count={this.state.counts.find(
               (count) => count.coachId === coach.id)}
            setMenuAnchor={this.props.setMenuAnchor}
            menuAnchor={menuAnchor}
            handlePrintPress={this.props.handlePrintPress}
            openEditCoach={this.props.openEditCoach}
            showEvaluations={this.showEvaluations}
            loadSurveys= {loadSurveys}
            handleSendEvalModalVisible={handleSendEvalModalVisible}
            coaches={coaches}
            midSeasonCheckin= {midSeasonCheckin }
            StartNewSurvey= {this.openStartEvaluationModal}
            ReopenSurvey={this.openContinueEvaluationModal}
            CancelSurvey= {this.openCancelEvaluationModal}
            schoolSlug={this.props.schoolSlug}
            userSubscription={this.props?.userSubscription}
            addonIDs={this.state.addonIDs}
          />
        );
      };

      private renderSportHeaderButtons(areAllCoachesCompleted: boolean) {
        const { classes, surveys } = this.props;
        const {
          startEvaluationSubmitting,
          endEvaluationSubmitting,
          cancelEvaluationSubmitting,
          continueEvaluationSubmitting,
        } = this.state;

        const survey = surveys[0];
        if (survey !== undefined) {
          // If the survey hasn't been closed
          if (survey.responseCollectionEndDate === null) {
            return (
              <Box
                display="flex"
                flexWrap="nowrap"
                justifyContent="space-between"
                width="100%"
              >
                <Box display="flex" gridGap="1.5rem">
                  <SurveyLink
                    category={EVALUATION_CATEGORIES.STUDENT}
                    code={survey.studentCode}
                    clickDisable={false}
                    isStarterPlan={false}
                    route={""}
                    schoolData={this.props.schoolData}
                  />
                  {survey.type === TemplateType.gritLeadership && (
                    <SurveyLink
                    schoolData={this.props.schoolData}
                      category={EVALUATION_CATEGORIES.COACH}
                      code={survey.coachCode}
                      clickDisable={false}
                      isStarterPlan={false}
                      route={""}
                    />
                  )}
                  {survey.parentCode && (
                    <SurveyLink
                      schoolData={this.props.schoolData}
                      category={EVALUATION_CATEGORIES.PARENT}
                      code={survey.parentCode}
                      clickDisable={false}
                      isStarterPlan={this.props?.userSubscription?.plans?.id===1?true:false}
                      route={`/${this.props.school.slug}/upgrade-subscription`}
                    />
                  )}
                </Box>

                <Box display="flex">
                  <Box>
                    <div className="stopButton">
                      <Button
                        onClick={this.endEvaluation}
                        className={classes.button}
                        variant="contained"
                      >
                        Close Survey
                      </Button>
                    </div>
                    {endEvaluationSubmitting && <LinearProgress />}
                  </Box>
                  <Box>
                    <div className="cancelbutton">
                      <Button
                        onClick={()=>{this.openCancelEvaluationModal()}}
                        className={`${classes.button}`}
                        color="secondary"
                        variant="outlined"
                      >
                        Cancel
                      </Button>
                    </div>
                    {cancelEvaluationSubmitting && <LinearProgress />}
                  </Box>
                </Box>


              </Box>
            );
          } else if (this.showEvaluations(survey)) {
            // Our end date plus the timeout is still valid, so display the results of the most recent survey
            return (
              <Grid item={true} key="links">
                <Box display="flex" alignItems="center" gridGap="1rem">
                  <Grid item={true}>
                    <div className="startNewEvaluation">
                      <Button
                        onClick={()=>{this.openStartEvaluationModal()}}
                        className={classes.button}
                        variant="contained"
                        color="primary"
                      >
                        Start New Survey
                      </Button>
                    </div>
                    {startEvaluationSubmitting && <LinearProgress />}
                  </Grid>
                  {!areAllCoachesCompleted && (
                    <Grid item={true}>
                      <Button
                        onClick={()=>{this.openContinueEvaluationModal()}}
                        className={classes.button}
                        variant="outlined"
                        color="secondary"
                      >
                        Reopen Previous Survey
                      </Button>
                      {continueEvaluationSubmitting && <LinearProgress />}
                    </Grid>
                  )}
                </Box>
              </Grid>
            );
          }
        }
        // The default return value, the start eval button
        return (
          <Grid item={true}>
            <div className="startEvaluation">
              <Button
                className={classes.button}
                onClick={this.startEvaluation}
                variant="contained"
                color="primary"
              >
                Start Survey
              </Button>
            </div>

          </Grid>
        );
      }

      private readonly closeCancelEvaluationModal = () =>
        this.setState({ cancelEvaluationModalVisible: false });

      private readonly openCancelEvaluationModal = (coachId?: number) =>
        this.setState({ cancelEvaluationModalVisible: true, coachiD: coachId ?? -1 });

      private renderCancelEvaluationModal() {
        const { cancelEvaluationModalVisible, cancelEvaluationSubmitting } =
          this.state;
        const { classes, sport } = this.props;
        return (
          <Modal
            open={cancelEvaluationModalVisible}
            closeModal={this.closeCancelEvaluationModal}
          >
            <div className="sport-table-model">
            <Grid
              container={true}
              style={{ height: "100%" }}
              direction="column"
              justifyContent="space-between"
            >
              <Typography variant="h4">
                Are you sure you want to cancel the most recent surveys for{" "}
                {sport.name}?
              </Typography>
              <Alert severity="warning">
                Warning!
                <br />
                <br />
                This will delete all data previously collected in this
                survey!
              </Alert>
              <Grid container={true} justifyContent="space-between">
                <Button
                  variant="contained"
                  onClick={this.closeCancelEvaluationModal}
                >
                  Close
                </Button>
                <Grid>
                  <Button
                    className={classes.cancelEvaluationButton}
                    onClick={this.cancelEvaluation}
                    variant="contained"
                  >
                    Cancel {sport.name} Surveys
                  </Button>
                  {cancelEvaluationSubmitting ? <LinearProgress /> : null}
                </Grid>
              </Grid>
            </Grid>
            </div>
          </Modal>
        );
      }

      private readonly closeContinueEvaluationModal = () =>
        this.setState({ continueEvaluationModalVisible: false });

      private readonly openContinueEvaluationModal = (coachId?:number) =>
        this.setState({ continueEvaluationModalVisible: true, coachiD: coachId ?? -1 });

      private renderContinueEvaluationModal() {
        const { continueEvaluationModalVisible, continueEvaluationSubmitting } =
          this.state;
        const { sport } = this.props;
        return (          
          <Modal
            open={continueEvaluationModalVisible}
            closeModal={this.closeContinueEvaluationModal}
          >
            <div className="sport-table-model">
            <Grid
              container={true}
              style={{ height: "100%" }}  
              direction="column"
              justifyContent="space-between"
            >
              <Typography variant="h4">
                Are you sure you want to reopen {sport.name} surveys?
              </Typography>
              <Grid container={true} justifyContent="space-between">
                <Button
                  variant="contained"
                  onClick={this.closeContinueEvaluationModal}
                >
                  Close
                </Button>
                <Grid>
                  <Button
                    onClick={this.continueEvaluation}
                    variant="contained"
                    color="primary"
                  >
                    Continue {sport.name} Surveys
                  </Button>
                  {continueEvaluationSubmitting ? <LinearProgress /> : null}
                </Grid>
              </Grid>
            </Grid>
            </div>
          </Modal>       
        );
      }

      private readonly closeStartEvaluationModal = () =>
        this.setState({ startEvaluationModalVisible: false });

      private readonly openStartEvaluationModal = (coachId?:number) =>
        this.setState({ startEvaluationModalVisible: true , coachiD: coachId ?? -1});

      private renderStartEvaluationModal() {
        const { startEvaluationModalVisible, startEvaluationSubmitting } =
          this.state;
        const { sport } = this.props;
        return (
          <Modal
            open={startEvaluationModalVisible}
            closeModal={this.closeStartEvaluationModal}
          >
            <Grid
              container={true}
              style={{ height: "100%", display: "flex" }}
              direction="column"
              justifyContent="space-between"
            >
              <Typography variant="h4">
                Are you sure you want to start a new {sport.name} survey?
              </Typography>
              <Grid style={{ display: "flex" }} container={true} justifyContent="space-between">
                <Button
                  variant="contained"
                  onClick={this.closeStartEvaluationModal}
                >
                  Close
                </Button>
                <Grid>
                  <Button
                    onClick={this.startEvaluation}
                    variant="contained"
                    color="primary"
                  >
                    Start new {sport.name} Survey
                  </Button>
                  {startEvaluationSubmitting ? <LinearProgress /> : null}
                </Grid>
              </Grid>
            </Grid>
          </Modal>
        );
      }

      private cancelEvaluation = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            cancelEvaluationSubmitting: true,
          },
          {
            cancelEvaluationSubmitting: false,
          },
          async () => {
            const { school, sport, midSeasonCheckin} = this.props;
            const {coachiD} = this.state;
            await this.buildPost<IEvaluationRequest, ISurveyResponse>(
              this,
              "survey/cancel"
            )({
              schoolId: school.id,
              sportId: sport.id,
                   ...(midSeasonCheckin && { coachId: coachiD })
            });
            this.closeCancelEvaluationModal();
            await this.props.loadSurveys(sport.id);
          },
          (ex: any) => {
            this.setState({ cancelEvaluationSubmitting: false });
            console.log("error", ex);
          }
        );

      private endEvaluation = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            endEvaluationSubmitting: true,
          },
          {
            endEvaluationSubmitting: false,
          },
          async () => {
            const { school, sport } = this.props;
            await this.buildPost<IEvaluationRequest, ISurveyResponse>(
              this,
              "survey/end"
            )({
              schoolId: school.id,
              sportId: sport.id,
            });
            await this.props.loadSurveys(sport.id);
          },
          (ex: any) => {
            this.setState({ endEvaluationSubmitting: false });
            console.log("error", ex);
          }
        );

      private startEvaluation = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            startEvaluationSubmitting: true,
          },
          {
            startEvaluationModalVisible: false,
            startEvaluationSubmitting: false,
          },
          async () => {
  const res: any = await this.buildGet<IUser>(this, "user")();
    const {coachiD} = this.state;
            const { school, sport, handleSendEvalModalVisible, midSeasonCheckin } = this.props;
            const surveyResponse = await this.buildPost<
              IEvaluationRequest & {userId: number, coachId?: number},
              ISurveyResponse
            >(
              this,
              "survey/start"
            )({
              schoolId: school.id,
              sportId: sport.id,
              userId: res?.id,
              ...(midSeasonCheckin && { coachId: coachiD })
            });
            await this.props.loadSurveys(sport.id);
            // open modal with the links
            handleSendEvalModalVisible(surveyResponse);
            // this.setState({ surveyResponse });
          },
          (ex: any) => {
            this.setState({ startEvaluationSubmitting: false });
            console.log("error", ex);
          }
        );

      private continueEvaluation = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            continueEvaluationSubmitting: true,
          },
          {
            continueEvaluationSubmitting: false,
          },
          async () => {
            const { school, sport, midSeasonCheckin } = this.props;
            const {coachiD} = this.state;
            await this.buildPost<IEvaluationRequest & {coachId?: number}, ISurveyResponse>(
              this,
              "survey/continue"
            )({
              schoolId: school.id,
              sportId: sport.id,
              ...(midSeasonCheckin && { coachId: coachiD })
            });
            this.closeContinueEvaluationModal();
            await this.props.loadSurveys(sport.id);
          },
          (ex: any) => {
            this.setState({ continueEvaluationSubmitting: false });
            console.log("error", ex);
          }
        );

        private readonly loadResponseCount = () =>
          void this.runCancellableStatefulAsync(
            this,
            {
              loadingResponseCount: true,
            },
            {
              loadingResponseCount: false,
            },
            async () => {
              const { schoolSlug, surveys, midSeasonCheckin } = this.props;
              // const { eachcoachiD } = this.state; // Single coachId
              
              if (!surveys?.length) {return};
        
              if (midSeasonCheckin === false) {
                const survey = surveys[0]; // Pehla survey pick kar rahe ho
                const res = await this.buildGetWithParams<
                  ISurveyCountResponse | undefined,
                  IDirectorParams
                >(this, `survey/response/count/${survey.id}`)({ schoolSlug });
        
                if (res !== undefined) {
                  this.setState({ counts: res.counts });
                }
              }
              //  else {
              //   // Coach ID ke surveys filter karo
              //   const coachSurveys = surveys.filter(s => s.coachId === eachcoachiD);
        
              //   if (coachSurveys.length > 0) {
              //     // Latest survey find karo
              //     const latestSurvey = coachSurveys.reduce((latest: any, current: any) => {
              //       const latestDate = latest.responseCollectionEndDate || latest.startDate;
              //       const currentDate = current.responseCollectionEndDate || current.startDate;
              //       return new Date(currentDate) > new Date(latestDate) ? current : latest;
              //     }, coachSurveys[0]);
        
              //     // API Call latest survey ke liye
              //     const res = await this.buildGetWithParams<
              //       ISurveyCountResponse | undefined,
              //       IDirectorParams
              //     >(this, `survey/response/count/${latestSurvey.id}`)({ schoolSlug });
        
              //     if (res !== undefined) {
              //       this.setState({ counts: res.counts });
              //       console.log(`Coach ${eachcoachiD} ka latest survey count:`, res.counts);
              //     }
              //   }
              // }
            },
            () => {
              this.setState({ loadingResponseCount: false });
            }
          );
               
      private showEvaluations = (sportSurvey: ISurvey | undefined) => {
        if (
          sportSurvey === undefined ||
          sportSurvey.responseCollectionEndDate === null
        ) {
          return false;
        }
        return true;
        // return sportSurvey.responseCollectionEndDate + SportTable.EVALUATION_TIMEOUT > Date.now();
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/SportTable.tsx